/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_Download_ButtonInputs */



/**
* | output |
* | --- |
* | "Download" |
*
* @param {Image_Export_Magnified_Download_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_download_button = /** @type {((inputs?: Image_Export_Magnified_Download_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Download_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Telecharger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scaricamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डाउनलोड करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Download")
	return /** @type {LocalizedString} */ ("Download")
});